import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import GuideArticle from "../pages/article/guide/page";
import TemplatesArticle from "../pages/article/templates/page";
import ComparisonArticle from "../pages/article/comparison/page";
import BeginnersArticle from "../pages/article/beginners/page";
import TipsArticle from "../pages/article/tips/page";
import SecurityArticle from "../pages/article/security/page";
import FeaturesArticle from "../pages/article/features/page";
import PricingArticle from "../pages/article/pricing/page";
import FaqArticle from "../pages/article/faq/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/vigorbuy-spreadsheet-guide",
    element: <GuideArticle />,
  },
  {
    path: "/vigorbuy-spreadsheet-templates",
    element: <TemplatesArticle />,
  },
  {
    path: "/vigorbuy-spreadsheet-comparison",
    element: <ComparisonArticle />,
  },
  {
    path: "/vigorbuy-spreadsheet-beginners",
    element: <BeginnersArticle />,
  },
  {
    path: "/vigorbuy-spreadsheet-tips",
    element: <TipsArticle />,
  },
  {
    path: "/vigorbuy-spreadsheet-security",
    element: <SecurityArticle />,
  },
  {
    path: "/vigorbuy-spreadsheet-features",
    element: <FeaturesArticle />,
  },
  {
    path: "/vigorbuy-spreadsheet-pricing",
    element: <PricingArticle />,
  },
  {
    path: "/vigorbuy-spreadsheet-faq",
    element: <FaqArticle />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;